import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { StringUtils } from "abweb/utils/StringUtils";
export class EvaluationContext {
  constructor(proto = null) {
    _defineProperty(this, "_value", void 0);
    // we need the prototype behavior of Object, so not Map.
    _defineProperty(this, "_proto", void 0);
    if (proto != null) {
      this._proto = proto;
    } else {
      this._proto = EvaluationContext._baseEvaluationContext;
    }

    // Set the Object prototype chain on _value, so that "get" will resolve the names by walking the chain.
    this._value = this._proto != null ? Object.create(this._proto._value) : {};
  }
  static setBaseEvaluationContext(context) {
    if (EvaluationContext._baseEvaluationContext == null) {
      EvaluationContext._baseEvaluationContext = context;
    } else {
      // add values from existing base.
      EvaluationContext._baseEvaluationContext.addProps(context);
    }
  }
  static getBaseEvaluationContext() {
    return EvaluationContext._baseEvaluationContext;
  }
  set(name, value) {
    this._value[name] = value;
    // this.defP(name);
  }
  get(name) {
    return this._value[name]; // undefined is OK!
  }
  get proto() {
    return this._proto;
  }
  set proto(ec) {
    this._proto = ec;
  }

  // noinspection JSAnnotator
  eval(expression) {
    const f = this.createEvaluationFunction(expression);
    return f();
  }
  addProps(ec) {
    for (const name in ec._value) {
      if (ec._value.hasOwnProperty(name)) {
        this.set(name, ec.get(name));
      }
    }
  }
  clone() {
    const ec = new EvaluationContext(this.proto);
    ec.addProps(this);
    return ec;
  }
  static expressionToBody(expression) {
    return StringUtils.startsWith(expression.trim(), "{") || /^\s*return/.exec(expression) ? expression : "return " + expression + ";";
  }
  createEvaluationFunction(expression) {
    const self = this.get("this");
    const params = [];
    const args = [];
    this.walkEvaluationContext(params, args);
    // eslint-disable-next-line @typescript-eslint/no-implied-eval
    const rawModelFn = new Function(params.join(","), EvaluationContext.expressionToBody(expression));
    const getModelValue = function () {
      return rawModelFn.apply(self /*provide 'this' context for functionBody*/, args);
    };
    return getModelValue;
  }
  createFunctionWithParams(paramNames, expression) {
    const self = this.get("this");
    let params = [];
    let args = [];
    let paramCount = paramNames.length;
    this.walkEvaluationContext(params, args); // start with EC's params & args

    params = params.concat(paramNames); // add user's params

    // eslint-disable-next-line @typescript-eslint/no-implied-eval
    const rawModelFn = new Function(params.join(","), EvaluationContext.expressionToBody(expression));
    const getModelValue = function (...a) {
      if (a.length !== paramCount) {
        throw new Error("Incorrect number of args");
      }
      let as = args.concat(a); // add user's args.
      return rawModelFn.apply(self, as);
    };
    return getModelValue;
  }
  walkEvaluationContext(params, args) {
    for (const name in this._value) {
      // No 'hasOwnProperty' check here, because we want to walk the prototype chain
      if (name !== "this") {
        params.push(name);
        args.push(this.get(name));
      }
    }
  }

  /**
   * Walks the proto chain to return the outermost EvaluationContext.
   * This is usually the EC of the containing component which is useful when it is necessary
   * to evaluate expressions in the context of the containing component.
   * Does NOT include the baseEvaluationContext.  To get that, use getBaseEvaluationContext().
   * @returns {EvaluationContext}
   */
  getContainerEC() {
    let ec = this;
    while (ec != null) {
      if (ec.proto === EvaluationContext._baseEvaluationContext) {
        break;
      }
      ec = ec.proto;
    }
    return ec;
  }
}
_defineProperty(EvaluationContext, "_baseEvaluationContext", null);
//# sourceMappingURL=EvaluationContext.js.map
